import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/timeline/index.js
// module id = 681
// module chunks = 0